import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useState } from "react";
import classNames from "classnames";

const InfoBoxClient: FC<Props> = ({
  label,
  createLabel,
  onCreateClick,
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <div
      className={classNames(
        styles.wrapper,
        isExpanded ? styles.expanded : null
      )}
    >
      <div className={styles.header}>
        <div
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
          className={styles.title}
        >
          {label}
        </div>
        {createLabel && (
          <div
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onCreateClick();
            }}
            className={styles.button}
          >
            +
            {/* <HollowButton text={`${createLabel}`} onClick={onCreateClick} /> */}
          </div>
        )}
      </div>
      <div className={styles.line}></div>
      <div className={styles.content}>{children}</div>

      {!isExpanded && <div className={styles.shadow}></div>}
    </div>
  );
};

export default InfoBoxClient;
